// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles_avatar__1fRx2","img":"styles_img__1b-w-","status":"styles_status__2JFrL"};